import request from '@/utils/request'
/**
 * 菜单管理API
 *
 * @author Jay Qing
 * @since 2020/11/27
 */

export const BASE_URL = '/system/menu'

export const TREE_URL = `${BASE_URL}/tree`

export function page(query: any) {
  return request({
    url: BASE_URL + '/page',
    method: 'get',
    params: query
  })
}

export function tree(query?: any) {
  return request({
    url: TREE_URL,
    method: 'get',
    params: query
  })
}

export function list(query: any) {
  return request({
    url: BASE_URL + '/list',
    method: 'get',
    params: query
  })
}

export function get(id: any) {
  return request({
    url: BASE_URL + '/get/' + id,
    method: 'get'
  })
}

export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}
